// The Clavian mark (BRAND.md §2, Eclipse, ADR-0060): the kit's ClavianMark, drawn with the theme's tokens
// so a venue's brand override reaches it. Flat (an ink ring, a red keyhole) on the console's working
// screens; eclipse (the ring in the brand's light) on a sign-in page. Decorative here: the link around it
// is named.

import { ClavianMark, type ClavianMarkVariant } from '@clavian/ui-web';

export function Mark({ size = 28, variant = 'flat' }: { readonly size?: number; readonly variant?: ClavianMarkVariant }) {
  return <ClavianMark className="console-mark" variant={variant} size={size} />;
}
